import { GatsbyImage } from 'gatsby-plugin-image';

import Button from '../../atoms/button/button';
import './simpleBanner.scss';
import { getAssetUrl } from '@/utils/contentFullAsset';

interface SimpleBannerInterface {
  copyBoton: string;
  imageSrc: any;
  redireccion: string;
  titulo: string;
  subtitulo: string;
}

const SimpleBanner = (props: SimpleBannerInterface) => {
  const { copyBoton, imageSrc, redireccion, titulo, subtitulo } = props;

  return (
    <div className="m-simpleBanner">
      <div className="m-simpleBanner__container">
        {imageSrc && imageSrc.gatsbyImage ? (
          <GatsbyImage
            loading="eager"
            className="m-simpleBanner__container__img"
            image={imageSrc.gatsbyImage}
            alt={imageSrc.description ?? 'Banner Comfama main'}
            title={imageSrc.description ?? 'Banner Comfama main'}
          />
        ) : (
          imageSrc.file &&
          imageSrc.file.url && (
            <img
              src={getAssetUrl(imageSrc)}
              alt={imageSrc.description ?? 'Banner Comfama main'}
              title={imageSrc.description ?? 'Banner Comfama main'}
              className="m-simpleBanner__container__img"
            />
          )
        )}
        <div className="m-simpleBanner__container__description">
          <div className="m-simpleBanner__container__description__titulo">
            <h2>{titulo}</h2>
          </div>
          <div className="m-simpleBanner__container__description__subtitulo">
            <h3>{subtitulo}</h3>
          </div>
          <div className="m-simpleBanner__container__description__search">
            <Button
              type="link"
              text={copyBoton}
              isDisabled={false}
              classname="m-simpleBanner__container__description__search__btn"
              href={redireccion}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleBanner;
